import classNames from 'classnames';
import uniqueId from 'lodash/uniqueId';
import * as React from 'react';
import type { FormFieldProps } from '../FormFieldProps';
import { useFrontendSettings } from '~/Features/Configuration/Hooks/useFrontendSettings';

export interface FormFieldTypeCheckboxProps extends FormFieldProps<boolean> {
    label?: string | React.ReactChild;
    className?: string;
}

export const FormFieldTypeCheckbox: React.FC<React.PropsWithChildren<FormFieldTypeCheckboxProps>> = React.memo(
    ({
        label,
        errorMessage,
        showErrorMessage = false,
        className,
        value,
        onChange,
        ...inputProps // name, onChange, onBlur, value
    }) => {
        const { checkboxVariant } = useFrontendSettings();
        const checkboxId = uniqueId('Checkbox__');
        const errorId = uniqueId('Error__');

        return (
            <div
                className={classNames(
                    'Form__field Form__fieldCheckbox',
                    `Variant--${checkboxVariant}`,
                    className,
                    showErrorMessage && 'Form__fieldError'
                )}
            >
                <input
                    type="checkbox"
                    className="Form__checkboxInput"
                    id={checkboxId}
                    checked={value}
                    onChange={e => onChange(e.target.checked)}
                    aria-describedby={errorId}
                    {...inputProps}
                />
                {label && (
                    <>
                        <label htmlFor={checkboxId} className="Form__label">
                            <span>{label}</span>
                        </label>
                        {showErrorMessage && (
                            <span id={errorId} className="Form__errorMessage">
                                {errorMessage}
                            </span>
                        )}
                    </>
                )}
            </div>
        );
    }
);
